import axios from "axios";
import getHost from "./getHost";

const post = async (path, data) => {
  return await axios.post(getHost() + path, data);
};

export default post;
